import React, { useCallback, useRef, useState } from 'react';
import TableView from '../TableView';
import {
	ApButtonIcon,
	ApButtonSecondary,
	ApInput,
	ApLoaderDefault,
	ApLoaderText,
	ApSimpleDropdown,
	ApToggleSwitch,
	colors,
	ApIcon,
} from '@alixpartners/ui-components';
import { GRAPHQL_PAYLOAD_DATA_UPDATE_HARMONIZED } from '../Constants';
import MultiSelect from 'SpendController/Components/MultiSelect/MultiSelect';
import { useWorkingCapitalFiltersContext } from '../Contexts/WorkingCapitalFiltersProvider';
import { SingleFilterWrapper } from 'SpendController/Components/Components.styles';
import { TableWrapper } from '../TableView/TableView.style';
import ToggleSidebar from 'CategoryManagement/Components/ToggleSidebar/ToggleSidebar';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Waves/Waves.styles';
import {
	CategoryInsightLabel,
	CategoryInsightValue,
	CategoryInsightRow,
	AbortPopup,
	ModalBody,
} from '../../../../../CategoryManagement/Insights/InsightsSettings/InsightsSettings.styles';
import Modal from 'components/Modal';
import MonthPicker from 'Settings/FirstUsageSettings/MonthPicker';
import { Breadcrumbs, ChartAndTableContainer } from '../WorkingCapital.styles';

export const DEFAULTCATEGORY = 'L4';
export const DEFAULTUNIT = 'm';
const HEADER_HEIGHT = 30;
const ROW_HEIGHT = 35;

function DataUpdate({ setCurrentContent }) {
	const {
		currentBreakDownFilter,
		currentFilterOptions,
		currentFilterValuesSelected,
		setcurrentFilterValuesSelected,
		handleFilterByChange,
		breakDownFilters,
		currentSelectedYear,
		updateFilterSettings,
		filterSettings,
		thresholdFilterSettings,
		setThresholdFilterSettings,
		saveThresholdFilters,
		isSaving,
		dateRangeData,
		handleDateRangeChange,
		dayDiff,
	} = useWorkingCapitalFiltersContext();
	const gridRef = useRef();
	const [currentGroupOpened, setCurrentGroupOpened] = useState();
	const [isEdited, setIsEdited] = useState(false);
	const [isDPOMultiplefilterData, setIsDPOMultipleFilterData] = useState('');
	const [currentGraphqlPayload] = useState(
		GRAPHQL_PAYLOAD_DATA_UPDATE_HARMONIZED
	);
	const [refresh, setRefresh] = useState(false);
	const handleRefreshGrid = () => {
		setRefresh(state => !state);
	};
	const [closeSettings, setCloseSettings] = useState(false);

	const columnDefs = [
		{
			field: 'label',
			headerName: 'Filter Name',
			flex: 5,
			cellRendererFramework: params => {
				if (params.data.value === 'HARMONIZED_VENDOR_NAME') {
					return (
						<span>
							{params.value?.toUpperCase()}
							<Tooltip
								position="bottom"
								animation="fade"
								arrow
								html={
									<TooltipContent
									>{`At least one filter must be enabled. Therefore, this filter cannot be disabled.`}</TooltipContent>
								}
								trigger="mouseenter"
								style={{
									marginLeft: '5px',
									position: 'relative',
									top: '6px',
								}}
							>
								<ApIcon
									iconName="info"
									iconSize="22px"
									outlined={true}
									iconColor={colors.green300}
								/>
							</Tooltip>
						</span>
					);
				} else {
					return params.value?.toUpperCase();
				}
			},
		},
		{
			field: 'isEnabled',
			headerName: 'Action',
			minWidth: 120,
			width: 120,
			maxWidth: 120,
			cellRendererFramework: params => {
				return (
					<>
						<ApToggleSwitch
							disabled={params.data.value === 'HARMONIZED_VENDOR_NAME'}
							color={colors.green100}
							checked={params.value}
							onChange={() => updateFilterSettings(params, setIsChanged)}
						/>
					</>
				);
			},
		},
	];
	const [isChanged, setIsChanged] = useState(true);
	const onGridReady = params => params.api.sizeColumnsToFit();

	const getGridOptions = () => {
		return {
			modules: AllModules,
			defaultColDef: {
				suppressMenu: true,
				comparator: () => 0,
			},
			rowHeight: ROW_HEIGHT,
			headerHeight: HEADER_HEIGHT,
			columnDefs,
			suppressCopyRowsToClipboard: true,
			suppressScrollOnNewData: true,
			suppressRowDrag: true,
			suppressRowClickSelection: true,
			suppressCellSelection: true,
			suppressCsvExport: true,
			suppressExcelExport: true,
			suppressContextMenu: true,
			suppressMultiSort: true,
			applyColumnDefOrder: true,
			domLayout: 'autoHeight',
			onGridReady: onGridReady,
			onRowDataChanged: params => {
				params.api.sizeColumnsToFit();
			},
		};
	};

	const renderSavingBlock = () => {
		return (
			<>
				{isSaving && (
					<AbortPopup>
						<Modal width="550px" zIndex="10000000">
							<ModalBody>
								Saving settings, please wait.<br />
								<ApLoaderDefault loaderText={() => <ApLoaderText />} />
							</ModalBody>
						</Modal>
					</AbortPopup>
				)}
			</>
		);
	};

	const onFilterChanged = useCallback(
		event => {
			const { api } = event;
			const filterModel = api.getFilterModel();
			const specificColumnFilter = filterModel['is_DPO_Multiple'];

			if (specificColumnFilter && specificColumnFilter.values.length === 0) {
				setIsDPOMultipleFilterData({
					key: 'is_DPO_Multiple',
					value: [],
				});
			} else {
				setIsDPOMultipleFilterData({
					key: 'is_DPO_Multiple',
					value: specificColumnFilter
						? specificColumnFilter.values[0] === 'YES'
							? ['1']
							: ['0']
						: ['1', '0'],
				});
			}
		},
		[setIsDPOMultipleFilterData]
	);

	return (
		<div>
			<Breadcrumbs>
				<span onClick={() => setCurrentContent(0)}>Category Widgets</span>&nbsp;/&nbsp;<span
				>
					Data Update
				</span>
			</Breadcrumbs>

			{isSaving && renderSavingBlock()}
			<div
				style={{
					display: 'flex',
					justifyContent: 'space-between',
					margin: '10px',
				}}
			>
				<div
					style={{
						display: 'flex',
						justifyContent: 'space-evenly',
						margin: '10px',
						alignItems: 'center',
					}}
				>
					{/* <ApSimpleDropdown
						label={`Date`}
						onChange={e => setCurrentSelectedYear(e)}
						options={YEAR}
						selected={YEAR.find(e => e.value === currentSelectedYear.value)}
					/> */}
					<ApSimpleDropdown
						label={`Filter By`}
						onChange={e => {
							handleFilterByChange(e);
							setIsDPOMultipleFilterData('');
						}}
						options={breakDownFilters}
						selected={breakDownFilters.find(
							e => e.value === currentBreakDownFilter.value
						)}
					/>
					<SingleFilterWrapper>
						<MultiSelect
							name={`${currentBreakDownFilter.label}`}
							label={`${currentBreakDownFilter.label}`}
							options={currentFilterOptions}
							selected={currentFilterValuesSelected}
							onChange={v => {
								setcurrentFilterValuesSelected(v);
								setIsDPOMultipleFilterData('');
							}}
						/>
					</SingleFilterWrapper>
					{dateRangeData.srcRange &&
						dateRangeData.stateRange && (
							<MonthPicker
								srcRange={dateRangeData.srcRange}
								stateRange={dateRangeData.stateRange}
								onConfirm={handleDateRangeChange}
							/>
						)}
				</div>
				<ToggleSidebar
					key={3}
					id={3}
					name={'capital_settings'}
					heading={'Working Capital Settings'}
					show={closeSettings}
					handleClose={() => setCloseSettings(state => !state)}
					width={'40%'}
					toRight={true}
				>
					<span style={{ margin: '15px', marginTop: '0px' }}>
						{isChanged ? (
							<TableWrapper>
								<div className="ag-theme-balham">
									<AgGridReact rowData={filterSettings} {...getGridOptions()} />
								</div>
							</TableWrapper>
						) : (
							<span />
						)}
					</span>
					<div style={{ margin: '15px', marginTop: '0px' }}>
						<span
							style={{
								color: `${colors.grey5}`,
								fontWeight: 600,
							}}
						>
							Default Settings
						</span>
						<CategoryInsightRow>
							<CategoryInsightLabel
							>{`P-Card threshold (No. of days)`}</CategoryInsightLabel>
							<CategoryInsightValue>
								<ApInput
									type="number"
									name="pcardThreshold"
									value={thresholdFilterSettings.pcardThreshold}
									onChange={v => {
										setThresholdFilterSettings({
											...thresholdFilterSettings,
											pcardThreshold: v,
										});
										setIsEdited(true);
									}}
								/>
							</CategoryInsightValue>
						</CategoryInsightRow>
						<CategoryInsightRow>
							<CategoryInsightLabel>
								{`Extend term threshold (No. of days)`}
							</CategoryInsightLabel>
							<CategoryInsightValue>
								<ApInput
									type="number"
									name="extendTermThreshold"
									value={thresholdFilterSettings.extendTermThreshold}
									onChange={v => {
										setThresholdFilterSettings({
											...thresholdFilterSettings,
											extendTermThreshold: v,
										});
										setIsEdited(true);
									}}
								/>
							</CategoryInsightValue>
						</CategoryInsightRow>
						<CategoryInsightRow>
							<CategoryInsightLabel>
								{`Vendor selection spend threshold ($ USD Low)*`}
								<Tooltip
									position="bottom"
									animation="fade"
									arrow
									html={
										<TooltipContent
										>{`Any vendor below this spend is shortlisted for WC optimization. By default max spend is selected which shortlists all vendors for optimization. User can manually go the view and unselect vendor from optimization.`}</TooltipContent>
									}
									trigger="mouseenter"
									style={{
										marginLeft: '5px',
										position: 'relative',
										top: '6px',
									}}
								>
									<ApIcon
										iconName="info"
										iconSize="22px"
										outlined={true}
										iconColor={colors.green300}
									/>
								</Tooltip>
							</CategoryInsightLabel>
							<CategoryInsightValue>
								<ApInput
									type="number"
									name="SelectBySpendThresholdLow"
									value={thresholdFilterSettings.SelectBySpendThresholdLow}
									onChange={v => {
										setThresholdFilterSettings({
											...thresholdFilterSettings,
											SelectBySpendThresholdLow: v,
										});
										setIsEdited(true);
									}}
								/>
							</CategoryInsightValue>
						</CategoryInsightRow>
						<CategoryInsightRow>
							<CategoryInsightLabel>
								{`Vendor selection spend threshold ($ USD High)*`}
								<Tooltip
									position="bottom"
									animation="fade"
									arrow
									html={
										<TooltipContent
										>{`Any vendor below this spend is shortlisted for WC optimization. By default max spend is selected which shortlists all vendors for optimization. User can manually go the view and unselect vendor from optimization.`}</TooltipContent>
									}
									trigger="mouseenter"
									style={{
										marginLeft: '5px',
										position: 'relative',
										top: '6px',
									}}
								>
									<ApIcon
										iconName="info"
										iconSize="22px"
										outlined={true}
										iconColor={colors.green300}
									/>
								</Tooltip>
							</CategoryInsightLabel>
							<CategoryInsightValue>
								<ApInput
									type="number"
									name="SelectBySpendThresholdHigh"
									value={thresholdFilterSettings.SelectBySpendThresholdHigh}
									onChange={v => {
										setThresholdFilterSettings({
											...thresholdFilterSettings,
											SelectBySpendThresholdHigh: v,
										});
										setIsEdited(true);
									}}
								/>
							</CategoryInsightValue>
						</CategoryInsightRow>
						<CategoryInsightRow>
							<CategoryInsightLabel>
								{`P-Card Spend threshold ($ USD)*`}
								<Tooltip
									position="bottom"
									animation="fade"
									arrow
									html={
										<TooltipContent
										>{`Any vendor less than or equal to entered value is considered for P-Card term.`}</TooltipContent>
									}
									trigger="mouseenter"
									style={{
										marginLeft: '5px',
										position: 'relative',
										top: '6px',
									}}
								>
									<ApIcon
										iconName="info"
										iconSize="22px"
										outlined={true}
										iconColor={colors.green300}
									/>
								</Tooltip>
							</CategoryInsightLabel>
							<CategoryInsightValue>
								<ApInput
									type="number"
									name="spendThreshold"
									value={thresholdFilterSettings.spendThreshold}
									onChange={v => {
										setThresholdFilterSettings({
											...thresholdFilterSettings,
											spendThreshold: v,
										});
										setIsEdited(true);
									}}
								/>
							</CategoryInsightValue>
						</CategoryInsightRow>
						<ApButtonSecondary
							onClick={() => {
								saveThresholdFilters(setCloseSettings, handleRefreshGrid);
							}}
							disabled={
								!thresholdFilterSettings.spendThreshold ||
								!thresholdFilterSettings.SelectBySpendThresholdLow ||
								!thresholdFilterSettings.SelectBySpendThresholdHigh ||
								!isEdited
							}
						>
							Save
						</ApButtonSecondary>
					</div>
				</ToggleSidebar>
				<span
					style={{
						margin: '10px',
						display: 'flex',
					}}
				>
					<ApButtonSecondary onClick={() => handleRefreshGrid('Refresssed')}>
						Refresh Rows
					</ApButtonSecondary>
					<div>
						<ApButtonIcon
							title={`Filters`}
							iconName="settings"
							iconProps={{ iconColor: colors.grey8 }}
							onClick={() => setCloseSettings(true)}
						/>
					</div>
				</span>
			</div>
			<ChartAndTableContainer>
				<TableWrapper>
					<TableView
						data={{ ...currentGraphqlPayload, currentGroupOpened }}
						parentGridRef={gridRef}
						handleGroup={setCurrentGroupOpened}
						selectedDate={currentSelectedYear}
						currentBreakDownFilter={currentBreakDownFilter.value}
						dateRangeData={dateRangeData}
						currentFilterValuesSelected={currentFilterValuesSelected}
						isDPOMultiplefilterData={isDPOMultiplefilterData}
						dataRefresh={refresh}
						onFilterChanged={onFilterChanged}
						dayDiff={dayDiff}
					/>
				</TableWrapper>
			</ChartAndTableContainer>
		</div>
	);
}

export default DataUpdate;
